import { render, staticRenderFns } from "./ReadingPlan.vue?vue&type=template&id=2b1dd8b3"
import script from "./ReadingPlan.vue?vue&type=script&lang=js"
export * from "./ReadingPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports